import { useEffect } from 'react'
import { useLiveQuery } from '@tanstack/react-db'

import { resolveReminderSettings } from '@/db/domain/customerReminders'
import { useDb } from '@/lib/dbContext'
import { ReminderSettingsSection } from '@/screens/ReminderSettingsSection'
import { useSectionSave } from '@/screens/useSectionSave'

/** The reminder schedule (delays, repeat, max age) on the Reminders page's Configure tab. */
export function ReminderSettingsPanel() {
  const db = useDb()
  const settingsResult = useLiveQuery((q) =>
    q.from({ settings: db.appSettingsCollection }),
  )
  const save = useSectionSave('Could not save the reminder settings. Please try again.')

  useEffect(() => {
    void db.appSettingsCollection.preload?.()
  }, [db])

  return (
    <ReminderSettingsSection
      value={resolveReminderSettings(settingsResult.data?.[0])}
      onSave={(value) =>
        save.run(() => db.saveReminderSettings(value), 'Reminder settings saved.')
      }
      isSaving={save.isSaving}
      errorMessage={save.errorMessage}
      successMessage={save.successMessage}
    />
  )
}
